import React, { useState, useRef, useEffect } from 'react';
import { getCompanyId, getToken, getUser, PermissionsCheck } from '../../Utils/Common';
import axios from 'axios';
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import { Typography } from "@mui/material";
import './Filter.scss';
import DraggableDialog from "../../components/Dialogs/DraggableDialog";
import Button from "@mui/material/Button";
import NumberInputSpinner from "../NumberInputSpinner/NumberInputSpinner";
import sharedContext from '../../contexts/shared-context';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

//const filterState = {};
const defaultFilterOperators = [
    {
        label: 'EQUALS(=)',
        value: '='
    },
    {
        label: 'CONTAINS(%)',
        value: '%'
    },
    {
        label: 'CONTAINS_ANY(%%)',
        value: '%%'
    },
    {
        label: 'IN(@)',
        value: '@'
    },
    {
        label: 'STARTS_WITH(^)',
        value: '^'
    },
    {
        label: 'ENDS_WITH($)',
        value: '$'
    },
    {
        label: 'EQUALS_OR_GREATER(>=)',
        value: '>='
    },
    {
        label: 'EQUALS_OR_LESS(<=)',
        value: '<='
    },
    {
        label: 'GREATER(>)',
        value: '>'
    },
    {
        label: 'LESS(<)',
        value: '<'
    },
    {
        label: 'NOT_EQUALS(!=)',
        value: '!='
    },
    {
        label: 'NOT_CONTAINS(!%)',
        value: '!%'
    },
    {
        label: 'NOT_CONTAINS_ANY(!%%)',
        value: '!%%'
    },
    {
        label: 'NOT_IN(!@)',
        value: '!@'
    },
    {
        label: 'NOT_STARTS_WITH(!^)',
        value: '!^'
    },
    {
        label: 'NOT_ENDS_WITH(!$)',
        value: '!$'
    },
    {
        label: 'IS_BLANK',
        value: ':IS_BLANK:'
    },
    {
        label: 'IS_NOT_BLANK',
        value: ':IS_NOT_BLANK:'
    }
];


function Filter({ fields, filterOperators = defaultFilterOperators, sortFields, apiURL, fetchData, reload, setNotify, useCompanyId = true, totalLabel, includeLimit = true, includeDeleted = false, includeCoreDocActions = false, includeDocActions = false, includeEnvisionDocActions = false, includeTotalDisplay, includeSort = true, tabName, maxLimit = 100, permission }) {

    const [openInstructionDialog, setOpenInstructionDialog] = useState(false);

    const [openReprocessInfoDialog, setOpenReprocessInfoDialog] = useState(false);
    const [openBulkInfoDialog, setOpenBulkInfoDialog] = useState(false);
    const [filterLimit, setFilterLimit] = useState(20);
    const [filterOffset, setFilterOffet] = useState(0);

    const [sortOrder, setSortOrder] = useState("asc");
    const [isShown, setOpenFilterPanel] = useState(true);

    const filterOperatorSelect = useRef(null);
    const filterFieldSelect = useRef(null);
    const filterTextArea = useRef(null);
    const filterOrderBy = useRef(null);
    const filterTotalText = useRef(null);
    const includeDeletedCheckbox = useRef(null);

    let filterPreferences = {
        filterTextArea: filterTextArea.current?.value || '',
        filterLimit: filterLimit,
        filterOffset: filterOffset,
        sortOrder: sortOrder,
        filterOrderBy: filterOrderBy.current?.value || ''
    };

    useEffect(() => {
        // check so 1st render does not do load
        if (reload) {
            handleLoadData();
        } else {
            if (tabName) {
                setFilterData();
            }
        }
    }, [reload]);

    useEffect(() => {
        if (tabName === 'documentIngestionTaskTab' || tabName === 'documentIngestionFileTab') {
            setFilterData();
        }
    }, [tabName]);

    useEffect(() => {
        const fltrTxt = JSON.parse(window.localStorage.getItem(tabName));
        if (fltrTxt !== null) {
            fltrTxt.filterTextArea = filterTextArea.current?.value;
        }
        window.localStorage.setItem(tabName, JSON.stringify(fltrTxt));
    }, [filterTextArea.current?.value]);

    useEffect(() => {
        const fltrField = JSON.parse(window.localStorage.getItem(tabName));
        if (fltrField !== null) {
            fltrField.filterOrderBy = filterOrderBy.current?.value;
        }
        window.localStorage.setItem(tabName, JSON.stringify(fltrField));
    }, [filterOrderBy.current?.value]);

    // create sorted array of field values only
    const sortFieldValues = sortFields ? sortFields.map((field) => field.field).sort() : null;

    const reprocessInstructionsDialogTitle = "Reprocess Instruction";
    const bulkInstructionsDialogTitle = "Bulk Operation Instruction";
    const filterInstructionsDialogTitle = "Filter Instruction";
    // get company id from header using sharedcontext
    const globalCompanyId = Number(React.useContext(sharedContext));
    const NO_COMPANY_ID = -1;
    const headerCompanyId = React.useContext(sharedContext); // need non converted to Number value

    const reprocessInstructionsTextContent =
        <>
            <Typography variant="body1" paragraph="true">
                <RotateRightOutlinedIcon style={{ verticalAlign: "middle" }} /> Conditional Reprocess: Server only updates the Machine Learning (ML) results to the CSP tenant.
            </Typography>

            <Typography variant="body1" paragraph="true">
                <AutorenewIcon style={{ verticalAlign: "middle" }} /> Force Reprocess: Server sends the docs to the ML and updates the ML results to the CSP tenant when available.Partial or Full.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The two button links above the table reprocess everything on the page.
                The bulk reprocess actions will skip any documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The two reprocess icons in the table reprocess individual document.
                The reprocess icons will be disabled for documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>
        </>;

    const envisionReprocessInstructionsTextContent =
        <>
            <Typography variant="body1" paragraph="true">
                <AutorenewIcon style={{ verticalAlign: "middle" }} /> Bulk Reprocess: Performs a bulk reprocess of all envision documents specified by the filter.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The bulk button below the filter reprocess multiple documents based on filter specified.
                The bulk reprocess action will skip any documents in DOCUMENT_DELETED or WORKFLOW_DELETED state
            </Typography>

            <Typography variant="body1" paragraph="true">
                The reprocess icon in the table reprocesses an individual document.
                The reprocess icon will be disabled for documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>
        </>;

    const bulkInstructionsTextContent =
        <>
            <Typography variant="body1" paragraph="true">
                <DeleteIcon style={{ verticalAlign: "middle" }} /> Bulk Delete: Performs a bulk delete of all core documents specified by the filter.
            </Typography>

            <Typography variant="body1" paragraph="true">
                <AutorenewIcon style={{ verticalAlign: "middle" }} /> Bulk Reprocess: Performs a bulk reprocess of all core documents specified by the filter.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The two bulk buttons below the filter reprocess or delete multiple documents based on filter specified.
                The bulk reprocess actions will skip any documents in DOCUMENT_DELETED or WORKFLOW_DELETED state
            </Typography>

            <Typography variant="body1" paragraph="true">
                The reprocess icon in the table reprocesses an individual document. The delete icon in the table deletes an individual document.
                The reprocess icon will be disabled for documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>
        </>;

    const filterInstructionsTextContent2 = `
    Please enter one row for one filter.

    Use date format as follows: 2018-09-21T10:00:00.000

    Sample Filter:
    companyid=1234
    documentGUID@0001025d-c58c-4cea-a693-1b78aff01027
    `;

    const handleLoadData = () => {
        //let totalFlag = false;
        let qparams = formQueryString();
        // console.log("load url ", apiURL);
        fetchData(apiURL, qparams);
        window.localStorage.setItem(tabName, JSON.stringify(filterPreferences));
        if (isShown === false) {
            setOpenFilterPanel(true);
        }
    };

    const setFilterData = () => {
        const filterOptn = JSON.parse(window.localStorage.getItem(tabName));
        if (filterOptn != null) {
            let fltrState = filterOptn['filterTextArea'];
            filterTextArea.current.value = fltrState;
            setFilterLimit(Number(filterOptn.filterLimit));
            setFilterOffet(Number(filterOptn.filterOffset));
            // not all pages i.e. IDP status tab have sort options so check for it.
            if (includeSort) {
                setSortOrder(filterOptn.sortOrder);
                let sortFieldValue = filterOptn['filterOrderBy'];
                filterOrderBy.current.value = sortFieldValue;
            }

            // set total text only for these tabs. Just safety check to prevent breaking existing code
            if (tabName === 'documentIngestionTaskTab' || tabName === 'documentIngestionFileTab') {
                if (filterOptn['filterTotalText'] !== undefined) {
                    filterTotalText.current.innerHTML = filterOptn['filterTotalText'];
                } else {
                    filterTotalText.current.innerHTML = '';
                }
            }
        } else {
            // set total text only for these tabs, Just safety check to prevent breaking existing code
            if (tabName === 'documentIngestionTaskTab' || tabName === 'documentIngestionFileTab') {
                // nothing set in localstorage so clear the total text
                filterTotalText.current.innerHTML = '';
            }
        }
    }

    const getCompanyIdFromFilter = (defaultCompanyId = 0) => {

        let filterText = filterTextArea.current.value;
        let filterCompanyId;
        let companyIdPrefix = "companyId=";
        let companyId_0_SetInFilter = false;
        if (filterText) {
            let filterList = filterText.split("\n");
            for (let filter of filterList) {
                if (filter.trim()) {
                    //filter = filter.trim();
                    if (filter.trim().startsWith(companyIdPrefix)) {
                        filterCompanyId = Number(filter.substring(companyIdPrefix.length));
                        if (filterCompanyId === 0) {
                            companyId_0_SetInFilter = true;    // used to differentiate between when company id is set to 0
                        }
                        break;
                    }
                }
            }
        }
        filterCompanyId = (filterCompanyId || companyId_0_SetInFilter) ? filterCompanyId : defaultCompanyId;

        if (tabName === 'documentIngestionTaskTab' || tabName === 'documentIngestionFileTab' || tabName === 'usersTab') {
            /*
             using direct sharedContext since need to differentiate between an entered value of 0 vs nothing.
             when empty string value is converted to number in globalCompanyId it is 0 so can't tell difference.
             */
            // if companyId in filter not set and global company id header not set, set to -1
            if ((filterCompanyId === 0 && !companyId_0_SetInFilter) && headerCompanyId === '') {
                filterCompanyId = NO_COMPANY_ID;
            }
        }
        return filterCompanyId;
    };

    const formQueryString = (totalFlag = false) => {
        let qparams = '';

        let filterValue = filterTextArea.current.value;
        let filterEx = "";
        let startTimeFilter = "startTime";
        let finishTimeFilter = "finishTime";
        let startTimePrefixes = ["startTime=", "startTime!=", "startTime<", "startTime<=", "startTime>", "startTime>="];
        let finishTimePrefixes = ["finishTime=", "finishTime!=", "finishTime<", "finishTime<=", "finishTime>", "finishTime>="];
        let documentIdpStatusDocGUIDFilter = "documentGUID";
        let documentIdpStatusBatchIdFilter = "batchId";
        let envisionDocumentTypeNameFilter = "name";
        let envisionDocumentTypeGetAll = "getAll";
        let envisionDocumentTypeNamePrefix = "name=";

        if (filterValue) {
            let filterList = filterValue.split("\n");
            for (const element of filterList) {
                if (element.trim()) {
                    let filterStr = '';
                    /*
                     need to special case the startTime and finishTime filter values since backend
                     needs the values in timestamp format. User enters value as more human readable
                     ISO date as user mostly likely is not going to know the timestamp value which
                     needs to be converted.
                     Also filter convention or instructions is to enter dates as ISO date in filter
                     */
                    if (element.trim().startsWith(startTimeFilter)) {

                        let startTimePrefix = startTimePrefixes.filter((filterPrefix) => {
                            let regEx = /\w+['=','!=','<','<=','>','>=']+/;
                            let searchTerms = element.trim().match(regEx);
                            if (searchTerms.length) {
                                return filterPrefix === searchTerms[0];
                            } else {
                                return false;
                            }
                        });

                        // check if we found a match. There should be only 1 match
                        if (startTimePrefix.length) {
                            const date = new Date(element.substring(startTimePrefix[0].length));
                            let startTimeTimestampVal = date.getTime();
                            filterStr = element.substring(0, startTimePrefix[0].length) + startTimeTimestampVal;
                        }
                    } else if (element.trim().startsWith(finishTimeFilter)) {

                        let finishTimePrefix = finishTimePrefixes.filter((filterPrefix) => {
                            let regEx = /\w+['=','!=','<','<=','>','>=']+/;
                            let searchTerms = element.trim().match(regEx);
                            if (searchTerms.length) {
                                return filterPrefix === searchTerms[0];
                            } else {
                                return false;
                            }
                        });

                        // check if we found a match. There should be only 1 match
                        if (finishTimePrefix.length) {
                            const date = new Date(element.substring(finishTimePrefix[0].length));
                            let finishTimeTimeStampVal = date.getTime();
                            filterStr = element.substring(0, finishTimePrefix[0].length) + finishTimeTimeStampVal;
                        }
                    } else if (tabName === 'documentIdpStatusTab') {
                        // add direct filter values as request params
                        if (element.trim().startsWith(documentIdpStatusDocGUIDFilter) ||
                            element.trim().startsWith(documentIdpStatusBatchIdFilter)) {
                            // add documentGUID or batchId as request params
                            qparams += `${element.trim()}&`;
                        }
                    } else if (tabName === 'envisionDocumentTypesTab') {
                        // add direct filter values as request params
                        if (element.trim().startsWith(envisionDocumentTypeNameFilter)) {
                            let name = element.substring(envisionDocumentTypeNamePrefix.length, element.trim().length);
                            // console.log(name);
                            if (name) {
                                apiURL = apiURL.replace("%NAME%", name);
                            } else {
                                apiURL = apiURL.replace("%NAME%", envisionDocumentTypeGetAll);
                            }
                        }
                    } else {
                        filterStr = element.trim();
                    }

                    // check if a filter string was set
                    if (filterStr !== '') {
                        filterEx += "&filter=" + filterStr;
                    }
                }
            }
        } else {
            // if no filter set, then use getAll for envision document types
            if (tabName === 'envisionDocumentTypesTab') {
                apiURL = apiURL.replace("%NAME%", envisionDocumentTypeGetAll);
            }

            let getPageName = apiURL.split('/').pop();
            if (getPageName === "histories?") {
                filterEx = globalCompanyId > 0 ? `&filter=objectCompanyId=${globalCompanyId}` : "&filter=";
            } else {
                filterEx = globalCompanyId > 0 ? `&filter=companyId=${globalCompanyId}` : "&filter=";
            }
        }

        // envision document types does not use these query params
        if (tabName !== 'envisionDocumentTypesTab') {
            if (totalFlag) {
                // only add filter if it exists
                if (filterEx !== '') {
                    qparams += encodeURI(filterEx); //append text area query
                }
            }
            else {

                qparams += 'startIndex=' + filterOffset + '&limit=' + filterLimit;

                // only add filter if it exists
                if (filterEx !== '') {
                    qparams += encodeURI(filterEx); //append text area query
                }
            }
        }

        //check if sort required
        if (includeSort) {
            if (filterOrderBy.current.selectedIndex !== 0) {
                if (sortOrder) {
                    qparams += '&sort=' + filterOrderBy.current.value + ' ' + sortOrder;
                }
            }
        }

        let deletedValue = false;
        if (includeDeleted) {
            // get value of checkbox
            deletedValue = includeDeletedCheckbox.current.checked;
        }

        // envision document types does not use these query params
        if (tabName !== 'envisionDocumentTypesTab') {
            if (totalFlag) {
                qparams += `&deletedOnly=${deletedValue}&details=true&mode=TOTAL`;
                if (includeDeleted) {
                    qparams += `&includeTrashed=${deletedValue}`;
                }
            }
            else {

                qparams += `&deletedOnly=${deletedValue}&details=true&mode=DATA`;
                if (includeDeleted) {
                    qparams += `&includeTrashed=${deletedValue}`;
                }

            }
        }


        // update API url with dynamic change to company 
        let filterCompanyId = getCompanyIdFromFilter(getCompanyId(true));

        if (filterCompanyId === 0 && globalCompanyId > 0) {
            apiURL = apiURL.replace("%COMPANY_ID%", globalCompanyId);
        } else {
            apiURL = apiURL.replace("%COMPANY_ID%", filterCompanyId);
        }
        return qparams;
    };

    const getTotalCount = () => {
        let totalFlag = true;
        let qparams = formQueryString(totalFlag);
        // console.log("total url ", apiURL);

        axios({
            method: "get", url: apiURL + qparams,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(useCompanyId), "Authorization": getToken() }
        })
            .then(response => {
                filterTotalText.current.innerHTML = `${response.data.total.toLocaleString()} ${totalLabel}`;
                if (tabName === 'documentIngestionTaskTab' || tabName === 'documentIngestionFileTab') {
                    // add total text to the filter preferences
                    filterPreferences.filterTotalText = filterTotalText.current.innerHTML;

                    window.localStorage.setItem(tabName, JSON.stringify(filterPreferences));
                }

            }).catch(error => {
                console.log('error in total count api call:', error);

                let message = `Failed to get total value: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const handleInfoDialogClose = () => {
        setOpenInstructionDialog(false);
    };

    const handleReprocessInfoDialogClose = () => {
        setOpenReprocessInfoDialog(false);
    };

    const handleBulkInfoDialogClose = () => {
        setOpenBulkInfoDialog(false);
    };

    const showFilterInstructions = (event) => {
        setOpenInstructionDialog(true);
    };

    const showReprocessInstructions = () => {
        setOpenReprocessInfoDialog(true);
    };

    const showBulkInstructions = () => {
        setOpenBulkInfoDialog(true);
    };

    const handleFilterPanel = () => {
        setOpenFilterPanel(!isShown);
    }

    const clearSearch = () => {
        //document.getElementById('filterTextArea').value = '';
        filterTextArea.current.value = '';
    };

    const handleAddField = () => {
        //let temp = document.getElementById('companyFilter').value + '' + document.getElementById('companyFields').value;
        let temp = filterTextArea.current.value + '' + filterFieldSelect.current.value;
        //document.getElementById('companyFilter').value = temp;
        filterTextArea.current.value = temp;
        filterTextArea.current.focus();
    };

    const handleAddOperator = () => {
        //let op = document.getElementById('companyOperator').value;
        let op = filterOperatorSelect.current.value;
        //document.getElementById('companyFilter').value = document.getElementById('companyFilter').value + '' + op;
        filterTextArea.current.value = filterTextArea.current.value + '' + op;
        filterTextArea.current.focus();

    };

    const resetCompanyField = () => {
        //document.getElementById('companyFields').selectedIndex = 0;
        filterFieldSelect.current.selectedIndex = 0;
    }

    const resetOperatorField = () => {
        //document.getElementById('companyOperator').selectedIndex = 0;
        filterOperatorSelect.current.selectedIndex = 0;
    };

    const onFilterLimitChanged = (value) => {
        setFilterLimit(value);
    };

    const onFilterOffsetChanged = (value) => {
        setFilterOffet(value);
    };

    const getFilterData = () => {
        let qparams = formQueryString(false);

        return axios({
            method: "get", url: apiURL + qparams,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(res => res.data);
        //.catch(err => console.error("get filter data failed: ", err));
    };

    const bulkEnvisionReprocess = () => {
        let dataResult = [];

        /*
        let filterCompanyId = getCompanyIdFromFilter(getCompanyId(true));
        if (includeCoreDocActions && filterCompanyId === '0') {
            let message = `Company ID must be set in filter for core documents`;
            setNotify({
                isOpen: true,
                message: message,
                severity: 'info',
                hideDuration: 5000
            });
            return;
        }
        */

        getFilterData().then(res => {
            dataResult = res;

            let reprocessPromises = [];
            let skippedDocDeletedStateCount = 0;
            let skippedWorkflowDeletedStateCount = 0;

            dataResult.data.forEach((data) => {
                let processState = data.state;

                if (processState !== 'DOCUMENT_DELETED' && processState !== 'WORKFLOW_DELETED') {
                    let companyId = data.companyId;
                    let documentGUID = data.documentGUID;

                    //let reprocessUrl = `/api/companies/${companyId}/${docCategory}/${documentGUID}/reprocess?`;
                    let reprocessUrl = `/api/companies/${companyId}/evDocuments/${documentGUID}/reprocess`;

                    reprocessPromises.push(axios({
                        method: "put", url: reprocessUrl,
                        headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
                    }).catch(error => { return error }));
                } else {
                    if (processState === 'DOCUMENT_DELETED') {
                        skippedDocDeletedStateCount++;
                    } else if (processState === 'WORKFLOW_DELETED') {
                        skippedWorkflowDeletedStateCount++;
                    }
                }
            });


            Promise.all(reprocessPromises).then((values) => {
                // console.log("all reprocess promise results: ", values);
                let reprocessedCount = values.length;
                let successReprocessCount = 0;
                let failedReprocessCount = 0;

                values.forEach((data) => {
                    if (data.status === 200) {
                        successReprocessCount++;
                    } else {
                        failedReprocessCount++;
                    }
                });

                // refresh table
                handleLoadData();

                let message = `Total ${reprocessedCount} enVision documents were initiated for reprocess \n\n`;

                message += ` successfully inititiated reprocess: ${successReprocessCount}
                failed inititiated reprocess : ${failedReprocessCount}
                skipped documents in DOCUMENT_DELETED state : ${skippedDocDeletedStateCount}
                skipped documents in WORKFLOW_DELETED state : ${skippedWorkflowDeletedStateCount}

                Please wait a few minutes and reload the table to view reprocess state`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info',
                    hideDuration: 5000
                });
            });
        }).catch(err => {
            console.log("Failed to retrieve data ", err);
            let message = `Failed to get data for bulk reprocess: \n\n ${err.response.statusText} : ${err.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        });

    };

    const bulkReprocess = (docCategory, useForceFlag = false, forceFlag = false) => {
        let dataResult = [];

        let filterCompanyId = getCompanyIdFromFilter(getCompanyId(true));
        if (includeCoreDocActions && filterCompanyId === '0') {
            let message = `Company ID must be set in filter for core documents`;
            setNotify({
                isOpen: true,
                message: message,
                severity: 'info',
                hideDuration: 5000
            });
            return;
        }

        getFilterData().then(res => {
            dataResult = res;

            let reprocessPromises = [];
            let skippedDocDeletedStateCount = 0;
            let skippedWorkflowDeletedStateCount = 0;

            dataResult.data.forEach((data) => {
                let processState = data.state;

                if (processState !== 'DOCUMENT_DELETED' && processState !== 'WORKFLOW_DELETED') {
                    let companyId = data.companyId;
                    let documentGUID = docCategory === 'documents' ? data.liveDocumentGUID : data.documentGUID;

                    let reprocessUrl = `/api/companies/${companyId}/${docCategory}/${documentGUID}/reprocess?`;

                    if (docCategory === 'documents') {
                        let processTypeVal = data.processType;
                        reprocessUrl += `processType=${processTypeVal}&`;
                    }

                    if (useForceFlag) {
                        reprocessUrl += `force=${forceFlag}`;
                    }

                    reprocessPromises.push(axios({
                        method: "put", url: reprocessUrl,
                        headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
                    }).catch(error => { return error }));
                } else {
                    if (processState === 'DOCUMENT_DELETED') {
                        skippedDocDeletedStateCount++;
                    } else if (processState === 'WORKFLOW_DELETED') {
                        skippedWorkflowDeletedStateCount++;
                    }
                }
            });


            Promise.all(reprocessPromises).then((values) => {
                // console.log("all reprocess promise results: ", values);
                let reprocessedCount = values.length;
                let successReprocessCount = 0;
                let failedReprocessCount = 0;

                values.forEach((data) => {
                    if (data.status === 200) {
                        successReprocessCount++;
                    } else {
                        failedReprocessCount++;
                    }
                });

                // refresh table
                handleLoadData();

                let message = `Total ${reprocessedCount} ${docCategory} were initiated for reprocess`;
                if (useForceFlag)
                    message += ` (force=${forceFlag}) \n\n`;
                else {
                    message += ` \n\n`;
                }
                message += ` successfully inititiated reprocess: ${successReprocessCount}
                failed inititiated reprocess : ${failedReprocessCount}
                skipped documents in DOCUMENT_DELETED state : ${skippedDocDeletedStateCount}
                skipped documents in WORKFLOW_DELETED state : ${skippedWorkflowDeletedStateCount}

                Please wait a few minutes and reload the table to view reprocess state`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info',
                    hideDuration: 5000
                });
            });
        }).catch(err => {
            console.log("Failed to retrieve data ", err);
            let message = `Failed to get data for bulk reprocess: \n\n ${err.response.statusText} : ${err.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        });

    };


    const bulkDelete = (processType) => {
        let dataResult = [];

        let filterCompanyId = getCompanyIdFromFilter(getCompanyId(true));
        if (includeCoreDocActions && filterCompanyId === '0') {
            let message = `Company ID must be set in filter for core documents`;
            setNotify({
                isOpen: true,
                message: message,
                severity: 'info',
                hideDuration: 5000
            });
            return;
        }

        getFilterData().then(res => {
            dataResult = res;

            let deletePromises = [];
            dataResult.data.forEach((data) => {
                let companyId = data.companyId;
                let documentGUID = data.documentGUID;

                let deleteUrl = `/api/companies/${companyId}/${processType}/${documentGUID}`;

                deletePromises.push(axios({
                    method: "delete", url: deleteUrl,
                    headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
                }).catch(error => { return error }));
            });


            Promise.all(deletePromises).then((values) => {
                // console.log("all delete promise results: ", values);
                let deletedCount = values.length;
                let successDeleteCount = 0;
                let failedDeleteCount = 0;

                values.forEach((data) => {
                    if (data.status === 200) {
                        successDeleteCount++;
                    } else {
                        failedDeleteCount++;
                    }
                });

                // refresh table
                handleLoadData();

                let message = `Total ${deletedCount} ${processType} were deleted \n\n 
                successfully deleted: ${successDeleteCount} 
                failed reprocess: ${failedDeleteCount}`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info',
                    hideDuration: 5000
                });
            });
        }).catch(err => {
            console.log("Failed to retrieve data ", err);
            let message = `Failed to get data for bulk delete: \n\n ${err.response.statusText} : ${err.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        });

    }

    const getResultContainerCssClass = () => {
        if (includeCoreDocActions) {
            return 'resultsContainer2';
        } else if (includeDocActions) {
            return 'resultsContainer3';
        } else {
            return 'resultsContainer1';
        }
    };

    const getFilterSectionContainerCssClass = () => {

        if (includeDeleted) {
            return 'filterSectionContainer2';
        } else {
            if (!includeSort) {
                return 'filterSectionNoSortContainer';
            } else {
                return 'filterSectionContainer';
            }
        }
    };

    return (
        <div>
            <div className={getResultContainerCssClass()}>
                <IconButton aria-label="open filter" onClick={handleFilterPanel} className={!isShown ? "activeFilter" : ""}>
                    <FilterAltIcon />
                </IconButton>
                <PermissionsCheck
                    errorProps={{ disabled: true }}
                    RenderError={() => <></>}
                    scopes={permission}>
                    <Button variant='contained' size="small" onClick={handleLoadData}
                        sx={{
                            lineHeight: 'normal',
                            textTransform: 'none',
                            background: '#82C027',
                            color: '#333330',
                            '&:hover': {
                                backgroundColor: '#82C027',
                                boxShadow: 'none',
                            }
                        }}>Load</Button>
                </PermissionsCheck>


                {(includeTotalDisplay || includeTotalDisplay === undefined) && (
                    <div className="totalContainer">
                        <div className="totalButton" onClick={getTotalCount} style={{ cursor: 'pointer' }}>
                            <div className="totalButtonContent">
                                <div className="totalButtonLabel">
                                    Total
                                </div>
                            </div>
                        </div>
                        <label id="totalText" ref={filterTotalText} className="totalLabel"></label>
                    </div>
                )}
                {includeCoreDocActions &&
                    (
                        <div id="coreDocButtonSection" className="coreDocButtonSection">
                            <Tooltip title="Bulk Delete: Performs a bulk delete of all core documents specified by the filter." placement="top" arrow>
                                <Button variant="text" startIcon={<DeleteIcon sx={{ fill: '#6F7687' }} />} onClick={() => bulkDelete('coreDocuments')} sx={{ textTransform: 'none' }}>
                                    Bulk Delete
                                </Button>
                            </Tooltip>

                            <Tooltip title="Bulk Reprocess: Performs a bulk reprocess of all core documents specified by the filter. Documents in DOCUMENT_DELETED or WORKFLOW_DELETED state will be skipped." placement="top" arrow>
                                <Button variant="text" startIcon={<AutorenewIcon sx={{ fill: '#6F7687' }} />} onClick={() => bulkReprocess('coreDocuments')} sx={{ textTransform: 'none' }}>
                                    Bulk Reprocess
                                </Button>
                            </Tooltip>

                            <IconButton sx={{ paddingLeft: '0px' }} aria-label="reprocess instructions" onClick={showBulkInstructions}>
                                <InfoIcon />
                            </IconButton>

                        </div>

                    )}

                {includeDocActions &&
                    (
                        <div id="docButtonSection" className="docButtonSection">
                            <Tooltip title="Force reprocess: Server sends all documents displayed below to the ML and updates the ML results to the CSP tenant when available. Documents in DOCUMENT_DELETED or WORKFLOW_DELETED state will be skipped." placement="top" arrow>
                                <Button variant="text" startIcon={<AutorenewIcon sx={{ fill: '#6F7687' }} />} onClick={() => bulkReprocess('documents', true, true)} sx={{ textTransform: 'none' }}>
                                    Force Reprocess All
                                </Button>
                            </Tooltip>

                            <Tooltip title="Conditional Reprocess: Server only updates the ML results to the CSP tenant on all documents displayed below. Documents in DOCUMENT_DELETED or WORKFLOW_DELETED state will be skipped." placement="top" arrow>
                                <Button variant="text" startIcon={<RotateRightOutlinedIcon sx={{ fill: '#6F7687' }} />} onClick={() => bulkReprocess('documents', true, false)} sx={{ textTransform: 'none' }}>
                                    Conditional Reprocess All
                                </Button>
                            </Tooltip>

                            <IconButton sx={{ paddingLeft: '0px' }} aria-label="reprocess instructions" onClick={showReprocessInstructions}>
                                <InfoIcon />
                            </IconButton>

                        </div>

                    )}

                {includeEnvisionDocActions &&
                    (
                        <div id="envisionDocButtonSection" className="docButtonSection">
                            <Tooltip title="Reprocess: Server sends all documents displayed below to the ML and updates the ML results when available. Documents in DOCUMENT_DELETED or WORKFLOW_DELETED state will be skipped." placement="top" arrow>
                                <Button variant="text" startIcon={<AutorenewIcon sx={{ fill: '#6F7687' }} />} onClick={() => bulkEnvisionReprocess()} sx={{ textTransform: 'none' }}>
                                    Reprocess All
                                </Button>
                            </Tooltip>

                            <IconButton sx={{ paddingLeft: '0px' }} aria-label="reprocess instructions" onClick={showReprocessInstructions}>
                                <InfoIcon />
                            </IconButton>

                        </div>

                    )}
            </div>
            <div className={isShown ? 'togglePanel' : ''}>
                <div id="filterContainer" className={!includeDeleted ? 'filterBox' : ''}>
                    <div className="filterContainer">
                        <div className="filter-actions-container">
                            <div id="content-left" className="filter-content-left">
                                <div id="filterTitle" className="filterTitle">Filters</div>

                                <IconButton sx={{ paddingLeft: '0px' }} aria-label="filter instructions" onClick={showFilterInstructions}>
                                    <InfoIcon />
                                </IconButton>

                            </div>
                            <div id="content-right" className="filter-content-right">

                                <div className="fieldDropdownContainer">
                                    <select id="filterFields" ref={filterFieldSelect} className="filterDropdown" style={{ width: '150px' }} onChange={handleAddField} onClick={resetCompanyField}>
                                        <option value="" selected>Add Field...</option>
                                        {fields.sort().map((field) => <option key={field}>{field}</option>)}
                                    </select>
                                </div>

                                <div className="fieldDropdownContainer">
                                    <select id="filterOperator" ref={filterOperatorSelect} className="filterDropdown" style={{ width: '150px' }} onChange={handleAddOperator} onClick={resetOperatorField}>
                                        <option value="" selected>Add Operator...</option>
                                        {filterOperators.map((filterOp) => <option key={filterOp.value} value={filterOp.value}>{filterOp.label}</option>)}
                                    </select>
                                </div>
                                <Button variant="text" size="small" onClick={clearSearch} sx={{ textTransform: 'none', lineHeight: 'normal', marginLeft: '95px' }}>Clear</Button>
                            </div>
                        </div>
                    </div>
                    <div id="filterSection" className={getFilterSectionContainerCssClass()} >
                        <div id="filterTextAreaContainer">
                            <textarea id="filterTextArea" ref={filterTextArea} className="filterTextArea" style={{ width: '574px', height: '112px', resize: 'none' }} name="filterText" rows="4" cols="100" placeholder='Add fields and operators...'></textarea>
                        </div>

                        {includeLimit &&
                            <div id="limitSection" className="limitSection">
                                <div className="rowDisplayTitle">Row Display</div>
                                <div className="limitItem">
                                    <label className="limitLabel">Items per load</label>
                                    <NumberInputSpinner name="limit" min={1} max={maxLimit} defaultValue={20} value={filterLimit} onChange={onFilterLimitChanged} />
                                </div>

                                <div className="offsetItem">
                                    <label className="skipLabel">Skip</label>
                                    <NumberInputSpinner name="offset" min={0} max={65535} defaultValue={0} value={filterOffset} onChange={onFilterOffsetChanged} />
                                </div>
                            </div>
                        }

                        {includeSort &&
                            (
                                <div id="sortOrderSection" className="sortSection">
                                    <div className="sortDisplayTitle">Sort</div>
                                    <div className="sortFieldItem">
                                        <label className="sortFieldLabel">Sort Field</label>
                                        <select id="sortBy" ref={filterOrderBy} className="filterDropdown">
                                            <option value="" selected>Sort Field...</option>
                                            {sortFieldValues.map((field) => <option key={field} value={field}>{field}</option>)}
                                        </select>

                                    </div>

                                    <div id="companyOrderAscending" className="sortOrderItem">
                                        <div id="radioSection1" className="sortRadio1">
                                            <label className="sortOrderLabel">Sort Order</label>
                                            <input type="radio" id="asc" name="sort-radio" value="asc" checked={sortOrder === 'asc'} onChange={e => setSortOrder(e.currentTarget.value)} />
                                            <label for="asc" className="sortLabel">ASC</label>
                                        </div>
                                        <div id="radioSection2" className="sortRadio2">
                                            <input type="radio" id="desc" name="sort-radio" value="desc" checked={sortOrder === 'desc'} onChange={e => setSortOrder(e.currentTarget.value)} />
                                            <label for="desc" className="sortLabel">DESC</label>
                                        </div>
                                    </div>

                                </div>
                            )}

                        {includeDeleted &&
                            (
                                <div id="deleteSection" className="deleteSection">
                                    <div className="deleteTitle">Exception</div>
                                    <div id="deleteCheckboxContainer" className="deleteCheckboxContainer">
                                        <input ref={includeDeletedCheckbox} id="deletedCheckbox" name="deletedCheckbox" type="checkbox" />
                                        <label for="deletedCheckbox" className="deleteLabel">Include Deleted Documents</label>
                                    </div>
                                </div>
                            )}


                    </div>
                </div>
            </div>

            <DraggableDialog
                open={openInstructionDialog}
                onClose={handleInfoDialogClose}
                title={filterInstructionsDialogTitle}
                content={<div style={{ whiteSpace: 'pre', fontFamily: 'Roboto', fontSize: '14px' }}>{filterInstructionsTextContent2}</div>}
            />

            <DraggableDialog
                open={openReprocessInfoDialog}
                onClose={handleReprocessInfoDialogClose}
                title={reprocessInstructionsDialogTitle}
                content={<div style={{ whiteSpace: 'pre-wrap', fontFamily: 'Roboto', fontSize: '14px' }}>{includeEnvisionDocActions ? envisionReprocessInstructionsTextContent : reprocessInstructionsTextContent}</div>}
            />

            <DraggableDialog
                open={openBulkInfoDialog}
                onClose={handleBulkInfoDialogClose}
                title={bulkInstructionsDialogTitle}
                content={<div style={{ whiteSpace: 'pre-wrap', fontFamily: 'Roboto', fontSize: '14px' }}>{bulkInstructionsTextContent}</div>}
            />

        </div>
    );

}

export default Filter;